<template>
  <b-card v-if="totalActiveFilters">
    <div :class="IS_MOBILE() ? '': 'd-flex align-items-center'">
      <h6
        v-if="!IS_MOBILE()"
        class="mb-1"
      >
        {{ $t("Active Filters") }}:
      </h6>
      <div class="filter-container">
        <div class="d-flex flex-wrap">
          <template v-for="([type, filters]) in Object.entries(getActiveFilters)">
            <template v-if="Array.isArray(filters)">
              <b-badge
                v-for="filter in filters"
                :key="`${type}-${filter?.id || filter}`"
                class="ml-1 rounded-pill mb-1"
                :variant="currentFilter(type).variant"
              >
                {{ $t(currentFilter(type)?.text) }}:
                {{ currentFilter(type)?.taggable ? filter : filter[currentFilter(type)?.optionLabel] }}
                <feather-icon
                  v-b-tooltip.hover="`Remove ${currentFilter(type)?.taggable ? filter : filter[currentFilter(type)?.optionLabel]}`"
                  icon="XIcon"
                  class="cursor-pointer"
                  @click="removeActiveFilter(filter[currentFilter(type).reduce] || filter, type)"
                />
              </b-badge>
            </template>

            <template v-else-if="filters !== null && filters !== '' && filters !== undefined">
              <b-badge
                :key="`${type}-single`"
                class="ml-1 rounded-pill mb-1"
                :variant="filters ? 'success' : 'secondary'"
              >
                {{ $t(currentFilter(type)?.text) }}:
                {{ currentFilter(type).inputType === 'tristate'
                  ? filters
                    ? currentFilter(type).tooltipYes
                    : currentFilter(type).tooltipNo
                  : filters }}
                <feather-icon
                  v-b-tooltip.hover="`Remove ${currentFilter(type)?.text}`"
                  icon="XIcon"
                  class="cursor-pointer"
                  @click="removeActiveFilter(filters, type)"
                />
              </b-badge>
            </template>
          </template>
        </div>
      </div>
      <b-badge
        v-b-tooltip.hover="'Clear all filters'"
        class="rounded-pill ml-1 mb-1 cursor-pointer"
        style="padding: 8px"
        variant="danger"
        @click="clearActiveFilters"
      >
        {{ $t('Clear All') }}
      </b-badge>
    </div>
  </b-card>
</template>

<script setup>
import { BCard, BBadge } from 'bootstrap-vue'
import useFilters from './useFilters'

const {
  getFilters, getActiveFilters, totalActiveFilters, removeActiveFilter, clearActiveFilters,
} = useFilters()

const currentFilter = type => getFilters.value[type]
</script>

<style lang="scss">
  .filter-container {
    display: inline-grid;
    grid-auto-flow: row dense;
    gap: 0.5rem;
  }
</style>
